

export const isValidNumber = (value) => {
    if (isNaN(value) || !isFinite(value)) {
        return false;
    }
    return true;
}

export const convertToNumber = (value = "") => {
    if (typeof value !== "string") {
        return value;
    }
    if (!value.includes(",")) {
        value = value + ",00";
    }
    const formattedValue = value.replace(',', '.');

    const numberValue = parseFloat(formattedValue);

    return numberValue;
}
